<template>
<div class="card ">
	<div class="dash-card-header col-sm-12">
		<div class="back-link pl-2">
			<button v-if="update" @click="hasHistory() ? $router.go(-1) : $router.push('/dashboard')">
				<img class="pull-left" src="@/assets/back.svg" >
			</button>
		</div>
		<div class="title-div font-medium font-size-15"><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t("transport")}}</div>
		<div class="logout-link">
			<img class="" src="@/assets/logout.svg" @click="logout">
		</div>
	</div>	
	
	<form class="col-sm-12">	
		<div class="form-group pt-8 pb-8 mr-0">	
			<div class="col-sm-12 ">{{$t('vervoer')}}</div>			
			<select class="form-select form-select-lg mt-5 pb-10 dropdown-toggle col-sm-12 " ref="transport" v-model="form.transport" >
				<option value="" selected>{{$t("choose")}}</option>
				<option value="0" >{{$t("foot")}}</option>
				<option value="1" >{{$t("bike")}}</option>
				<option value="3" >{{$t("car")}}</option>
				<option value="4" >{{$t("motorbike")}}</option>
				<option value="2" >{{$t("public_trans")}}</option>
			</select>					
		</div>

				<input type="hidden" v-model="form.hasCar">
		<div class="form-group pt-8 pb-8 mr-0">	
			<div class="col-sm-12 pb-2 pt-8">{{$t("ihadl")}}</div>			
			<select class="form-select form-select-lg mt-5 dropdown-toggle col-sm-12 " v-model="form.haveDriversLicense" >
				<option value="none" selected>{{ $t("choose") }}</option>
				<option value="1" >{{ $t("yes") }}</option>
				<option value="0" >{{ $t("no") }}</option>
			</select>
		</div>
		<div v-if="form.haveDriversLicense==1" class="form-group pt-8 pb-8 mr-0">	
			<div class="col-sm-12 pb-2 pt-8">{{ $t('license_type')}}</div>			
			<select class="form-select form-select-lg mt-5 dropdown-toggle col-sm-12 " v-model="form.licenseType" >
				<option value="0" selected>{{ $t("choose") }}</option>
				<option value="AM" >{{ $t("driver_am") }}</option>
				<option value="A" >{{ $t("driver_a") }}</option>
				<option value="B" >{{ $t("driver_b") }}</option>
				<option value="C" >{{ $t("driver_c") }}</option>
				<option value="D" >{{ $t("driver_d") }}</option>
			</select>					
		</div>
		<div class="form-group pt-8 pb-8 mr-0">		
			<div class="col-sm-12 pb-2 pt-8">{{$t("iwswj")}}</div>		
			<select class="form-select form-select-lg mt-5 dropdown-toggle col-sm-12" ref="radius" v-model="form.radius" >
				<option value="0" selected>{{ $t("choose") }}</option>
				<option value="10" >{{ $t("10km") }}</option>
				<option value="20" >{{ $t("20km") }}</option>
				<option value="30" >{{ $t("30km") }}</option>
				<option value="50" >{{ $t("50km") }}</option>
				<option value="80">{{ $t("+50km") }}+</option>
			</select>					
		</div>
		<br>
		<div v-if="error" class="form-group col-sm-12 text-center">
			<div class=" p-4 btn-danger">{{error}}</div>
		</div>
		<div v-if="update" class="form-group col-sm-12 mt-5">
			<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block" :disabled="loading">{{$t("save")}}</button>
		</div>
		<div v-else class="form-group col-sm-12 mt-5">
			<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block" :disabled="loading">{{$t("next")}}</button>
		</div>
	</form>
</div> 
</template>
<script>
export default {
	props: ['update', 'initialLoad'],
    data() {
        return {
            form:{
                transport: 12,
                hasCar: 'none',
                haveDriversLicense: 'none',
                licenseType: 0,
				email:'',
				radius: ''
            },
            error: '',
			assessmentTaken: false
        }
    },
	mounted() {	
		window.scrollTo(0,0)		
		let user = JSON.parse(localStorage.getItem('user'))
		
		if (user) {
			this.form.ukey = user.ukey
			this.form.transport = String(user.transportation)
			this.form.radius = String(user.radius)
			this.form.haveDriversLicense = String(user.haveDriversLicense)

			if (user.hasCar != 'none') {
				this.form.hasCar = user.hasCar
			}
			
			if (user.licenseType) {
				this.form.licenseType = user.licenseType
			}
			if (user.radius.toString() == 25) {
				this.form.radius = '0';
			}
			
			this.assessmentTaken = user.assessmentTaken
		}
	},
    methods:{
		hasHistory () { return window.history.length > 2 },
		async saveForm() { 			
			this.error = null;		
			if (!this.form.licenseType && this.form.haveDriversLicense == 'none') {
				this.error = this.$t('perd') 
				return;
			}
			if (this.form.radius == 0) {
                this.$refs.radius.classList.add('bg-color-red-border')
                this.error = this.$t('perd')
                return;
            }
			if (this.form.transport == '') {
				 this.$refs.transport.classList.add('bg-color-red-border')
				this.error = this.$t('perd') 
				return;
			}
			this.$refs.radius.classList.remove('bg-color-red-border')
			this.$refs.transport.classList.remove('bg-color-red-border')
			try {
				await this.$store.dispatch('registerTransportation', this.form);
				if (!this.assessmentTaken) {
					await this.$router.push({ name: 'assessment'});
				}
				await this.$router.push({ name: 'dashboard'});
			} catch (error) { 
				if(error.response && error.response.data && error.response.data.message) {
					this.error = error.response.data.message;
				}
				await this.$router.push({ name: 'dashboard'});
			} 
         },
		 async logout(){ 
			this.error = null;
			try {
				await this.$store.dispatch('logout');
				await this.$router.push({ name: 'home' });
			} catch (error) {
				this.error = error;
			} finally {
				this.loading = false;
			}
         }
    }
}
</script>
